import { render } from "./GuestSuppliesPanel.vue?vue&type=template&id=d56244de&scoped=true"
import script from "./GuestSuppliesPanel.vue?vue&type=script&lang=js"
export * from "./GuestSuppliesPanel.vue?vue&type=script&lang=js"

import "@/css/GuestsPage.css?vue&type=style&index=0&lang=css&external"
import "./GuestSuppliesPanel.vue?vue&type=style&index=1&id=d56244de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d56244de"]])

export default __exports__